<div *ngIf="!extendedComponent">
    <personnel-picker-content
        [showSelectedPerCount]="showSelectedPerCount"
        [selectionMode]="selectionMode"
        [personnelPicker]="personnelPicker"
        [disabled]="disabled"
        [queryModel]="queryModel"
        (valueEvent)="valueEvent.emit($event)"
        [authorizationRoleTypeCodeList]="authorizationRoleTypeCodeList"
        [addButtonLabel]="addButtonLabel"
        [searchable]="searchable"
        [searchQueryModel]="searchQueryModel"
        (onSearchPersonnelSelected)="onSearchPersonnelSelectedF($event)"
        [isIdentityNumberRequired]="isIdentityNumberRequired"
        [showTopOrg]="showTopOrg"
        (onFilteredPerSelected)="onFilteredPerSelected($event)"
        [showSelectedPersonnel]="showSelectedPersonnel"
        [rowsPerPageOptions] ="rowsPerPageOptions"
    ></personnel-picker-content>
</div>
<ng-container #extendedCompContainer></ng-container>
